import { render } from "./QueueDeleteForm.vue?vue&type=template&id=22829c26&ts=true"
import script from "./QueueDeleteForm.vue?vue&type=script&lang=ts"
export * from "./QueueDeleteForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__